import HttpRequest from "@/plugins/axios";

class QuestionnaireProvider extends HttpRequest {
    constructor() {
        // api api
        super(process.env.VUE_APP_API_URL)
    }

    async getQuestionnaire(uid) {
        const { data } = await this.get('/', {
            function: 'get-student-review',
            uid,
        })
        return data
    }

    async setQuestionnaire(info) {
        const { data } = await this.update('/', {
            function: 'save-student-review',
            uid: info.uid,
            DEVICE: info.DEVICE,
            NEWS: info.NEWS,
            NEWS_OTHER: info.NEWS_OTHER,
            Q1_1: info.Q1_1,
            Q1_2: info.Q1_2,
            Q1_3: info.Q1_3,
            Q1_4: info.Q1_4,
            Q1_5: info.Q1_5,
            Q2_1: info.Q2_1,
            Q2_2: info.Q2_2,
            Q2_3: info.Q2_3,
            Q2_4: info.Q2_4,
            Q2_5: info.Q2_5,
            Q3_1: info.Q3_1,
            Q3_2: info.Q3_2,
            Q3_3: info.Q3_3,
            Q3_4: info.Q3_4,
            Q3_5: info.Q3_5,
            COMMENT_1: info.COMMENT_1,
            COMMENT_2: info.COMMENT_2,
        })
        return data
    }
}

export default QuestionnaireProvider